import React, { Component } from 'react';

import ReactQuill from 'react-quill'; 
import Cropper from "react-cropper";

import 'react-quill/dist/quill.snow.css';
import '../styles/ReactQuill.css'
import "cropperjs/dist/cropper.css";
import GridImagesComponent from '../components/GridImagesComponent';
import NovedadFieldComponent from '../components/NovedadFieldComponent';
import StockAdjustModal from '../components/StockAdjustModal';
import { NOVEDADES_SLUG } from '../utils/collectionsApi';
import { loadProductImages } from '../utils/productImages';
import { getProviders } from '../utils/functions';
import { limpiarExternalIds, externalIdsInvalidos } from '../utils/productForm';
import { crearPrecarga } from '../utils/formPreload';

var config = process.env;

class FormBoxGameComponent extends Component {
    
	constructor(){
        super();
        this.state = { 
            editMode: false,
            text: '',
            prefix: '',
            code: '',
            images: {},
            // ¿Todavía están bajando las imágenes que el accesorio YA tiene? Mientras sea true el
            // botón Guardar está deshabilitado: guardar con el mapa a medio llenar borra del
            // bucket lo que no llegó (ver el comentario de deleteImages en EditProductPage).
            imagesLoading: false,
            externalIds: [],
            accessories: [],
            relatedProduct1: -1,
            relatedProduct2: -1,
            relatedProduct3: -1,
            currentStock: 0,
            currentName: '',
            adjustingStock: false,
            providers: [],
            // Colecciones a las que pertenece el producto (slugs que trae GET /product/:code).
            labels: [],
            // Valor de "Novedad" TAL COMO SE CARGÓ. null = alta (no hay valor previo).
            // Es la mitad del dirty-tracking: al guardar, `isNew` sólo viaja si difiere de esto.
            // Ver el comentario largo en onClickSave.
            loadedIsNew: null,
            // Campos que la precarga no pudo escribir, e ídem para un fallo entero del fetch.
            // Cualquiera de los dos con contenido significa que la ficha NO refleja lo que hay
            // en la base, y entonces guardar sólo puede pisar datos buenos con los defaults del
            // markup: el botón queda deshabilitado. Ver src/utils/formPreload.js.
            camposSinCargar: [],
            precargaRota: false,
        }
        this.handleChangeDescription = this.handleChangeDescription.bind(this);
    }

    // ¿Estamos editando? Se sabe desde el primer render (por el prop), a diferencia de
    // `state.editMode`, que recién se prende cuando vuelve el fetch. Lo necesita el
    // `defaultValue` del control "Novedad", que React aplica una sola vez, al montar.
    isEditing = () => this.props.code !== undefined && this.props.code !== '';
    
    async componentDidMount() {
        // Antes del primer `await`: en edición las imágenes existentes van a estar en vuelo, y
        // el botón tiene que nacer deshabilitado, no habilitarse recién cuando arranca la bajada.
        if (this.isEditing()) {
            this.setState({ imagesLoading: true });
        }

        let providers = await getProviders("product")
        this.setState({ providers: providers })

        if (this.props.code != undefined && this.props.code != '') {
            this.fetchData(this.props.code)
        } else {
            this.fetchRelatedProduct();
        }

        document.addEventListener("wheel", function(event){
            if(document.activeElement.type === "number"){
                document.activeElement.blur();
            }
        });
    }

    fetchRelatedProduct = () => {
        //Load RelatedProducts
        var request = {
            method: 'GET',
            headers: { 
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'product', request)
        .then(results => { return results.json(); })
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                var list = [];
                data.data.forEach(item => {
                    list.push({
                        code: item.code,
                        name: item.name
                    });
                });
                this.setState({ accessories: list });
                this.loadRelatedProducts(list);
            }
        });
    }

    loadRelatedProducts = (list) => {
        var x1 = document.getElementById("relatedProduct1");
        var x2 = document.getElementById("relatedProduct2");
        var x3 = document.getElementById("relatedProduct3");
        list.forEach(item => {
            var option1 = document.createElement("option");
            var option2 = document.createElement("option");
            var option3 = document.createElement("option");
            option1.text = item.name;
            option1.value = item.code;
            if (this.state.relatedProduct1 == item.code) {
                option1.defaultSelected = true
            }

            option2.text = item.name;
            option2.value = item.code;
            if (this.state.relatedProduct2 == item.code) {
                option2.defaultSelected = true
            }

            option3.text = item.name;
            option3.value = item.code;
            if (this.state.relatedProduct3 == item.code) {
                option3.defaultSelected = true
            }
            if (item.code != this.state.code) {
                x1.add(option1);
                x2.add(option2);
                x3.add(option3);
            }
        });
    }

    fetchData = (code) => {
        var request = {
            method: 'GET',
            headers: { 
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'product/' + code, request)
        .then(results => { return results.json(); })
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                if (data.data.relatedProducts.length == 1) {
                    this.setState({ relatedProduct1: data.data.relatedProducts[0].code });
                } else if (data.data.relatedProducts.length == 2) {
                    this.setState({ 
                        relatedProduct1: data.data.relatedProducts[0].code,
                        relatedProduct2: data.data.relatedProducts[1].code
                    });
                } else if (data.data.relatedProducts.length == 3) {
                    this.setState({ 
                        relatedProduct1: data.data.relatedProducts[0].code,
                        relatedProduct2: data.data.relatedProducts[1].code,
                        relatedProduct3: data.data.relatedProducts[2].code
                    });
                }
                const detail = data.data.accessory || data.data.product;
                this.setState({
                    externalIds: data.data.externalItems != null ? data.data.externalItems : [],
                    currentStock: detail.stock,
                    currentName: detail.name,
                })
                this.loadData(detail);
                this.fetchRelatedProduct();
            }
        })
        // Última red: si la precarga falla por algo que el helper no puede anotar (el fetch se
        // cae, el payload viene con otra forma), la ficha igual queda a medio llenar. Que se vea
        // y que no se pueda guardar; antes esto era un rejection mudo en la consola.
        .catch(error => {
            console.error('[ficha de accesorio] no se pudo precargar la ficha:', error);
            this.setState({ precargaRota: true });
        });

        // Imágenes que ya están en el bucket. `setState` funcional porque llegan en paralelo:
        // copiar `this.state.images` haría que dos que resuelven juntas lean el mismo state viejo
        // y una pise a la otra.
        loadProductImages(`/accessories/${code}`, (position, dataUrl) => {
            this.setState((prev) => ({
                images: { ...prev.images, [position]: { path: dataUrl, position } },
            }));
        })
        .catch(error => {
            // Accesorio sin imágenes todavía: no es un error, la pantalla sigue funcionando.
            console.log(error);
        })
        // Resuelva o falle, ya no queda nada en vuelo: recién acá el mapa refleja lo que hay en
        // el bucket y el guardado puede reescribir la carpeta.
        .finally(() => this.setState({ imagesLoading: false }));
    }

    // Precarga la ficha. OJO: sólo corre en EDICIÓN (la llama `fetchData`, y `fetchData` sólo se
    // llama con un `code`), así que acá no hay que escribirle a ningún campo que exista sólo en
    // el alta. El `#stock` es exactamente ese caso: desde que el stock se mueve con "Ajustar
    // stock" el input existe sólo en el alta, y la línea que le escribía acá tiraba TypeError y
    // se llevaba puesto todo lo de abajo. El stock en edición se muestra desde
    // `state.currentStock`, que ya se setea en `fetchData`.
    //
    // Cada campo va por `precarga.set` en vez de `getElementById(...).value` para que un id que
    // falte NO corte el resto (ver src/utils/formPreload.js). La contracara es el bloqueo del
    // guardado de abajo: una ficha incompleta no puede pisar la base.
    loadData = (data) => {
        const precarga = crearPrecarga('ficha de accesorio');
        precarga.set("code", data.prefix + data.code);
        precarga.set("name", data.name);
        precarga.set("price", data.price);
        precarga.set("discount", data.discount);
        precarga.set("minStock", data.minStock);
        precarga.set("suggestionStock", data.suggestionStock);
        precarga.set("provider", data.provider);
        // `type` es la columna legacy de categoría y en fichas viejas puede venir NULL. El select
        // no tiene opción "sin especificar": escribirle null lo deja EN BLANCO y el guardado lo
        // mandaría como 0. Se deja el default del markup, que es lo que esas fichas vienen
        // mostrando desde siempre. (Con valor sí se escribe: el detalle de staff devuelve la
        // columna real, no el discriminador juego/accesorio del payload público.)
        if (data.type != null && data.type !== '') {
            precarga.set("type", data.type);
        }
        precarga.set("sku", data.sku);
        precarga.set("bar_code", data.barCode);
        precarga.set("code-ml", data.codeML);
        precarga.set("cost", data.cost);
        precarga.set("display", data.display == 1);
        // "Novedad" se precarga desde la MEMBRESÍA en la colección, no desde `data.isNew`. Es el
        // mismo valor (el backend deriva uno del otro), pero leerlo de `labels` deja el control
        // atado explícitamente a "está o no etiquetado en Novedades", que es exactamente lo que
        // el guardado escribe. Si mañana los dos discrepan, el control muestra la fuente de
        // verdad y no el campo derivado.
        const labels = Array.isArray(data.labels) ? data.labels : [];
        const isNewCargado = labels.indexOf(NOVEDADES_SLUG) !== -1;
        precarga.set("isNew", isNewCargado);
        this.setState({
            editMode: true,
            text: data.description,
            prefix: data.prefix,
            code: data.code,
            labels: labels,
            loadedIsNew: isNewCargado,
            camposSinCargar: precarga.faltantes(),
        });
    }

    // ¿La ficha refleja lo que hay en la base? Si no, guardar sólo puede escribir los defaults
    // del markup encima de datos buenos, y ninguna validación lo ataja (un `<select>` en su
    // primera opción no está vacío, está mal). Fail closed.
    precargaIncompleta = () => (
        this.state.precargaRota || this.state.camposSinCargar.length > 0
    );

    handleChangeDescription(value) {
        this.setState({ text: value })
    }

    checkIsValid = (input) => {
        if (input.value == null || input.value == undefined || input.value == '') {
            input.className = "form-control is-invalid";
            return true;
        } else {
            input.className = "form-control";
            return false;
        }
    }

    onClickSave = () => {
        // El botón ya está deshabilitado en este caso; esto es la guarda de adentro, para que el
        // bloqueo no dependa de un atributo del render. Guardar una ficha que no terminó de
        // cargar escribe los defaults del markup encima de los datos buenos.
        if (this.precargaIncompleta()) {
            alert(
                'La ficha no se cargó completa, así que guardar pisaría los datos del accesorio '
                + 'con valores por defecto.\n\nRecargá la pantalla. Si vuelve a pasar, avisá: '
                + 'el detalle está en la consola del navegador.',
            );
            return;
        }

        // Establezco la primer img como thumbnail
        let images = {};
        let thumb_pos = 100;
        let thumb_img = "";
        let mapImages = this.state.images;
        Object.keys(mapImages).forEach((key) => {
            if (mapImages[key].path != undefined && mapImages[key].path != '') {
                images[mapImages[key].position] = mapImages[key];
                if (mapImages[key].position != "thumbnail" && parseInt(mapImages[key].position) < parseInt(thumb_pos)) {
                    thumb_pos = mapImages[key].position;
                    thumb_img = mapImages[key].path;
                }
            }
        });
        if (thumb_pos != 100) {
            images["thumbnail"] = { path: thumb_img, position: "thumbnail" }
        }

        var name = document.getElementById("name");
        var price = document.getElementById("price");
        var minStock = document.getElementById("minStock");
        var suggestionStock = document.getElementById("suggestionStock");
        var provider = document.getElementById("provider").value;
        var type = document.getElementById("type").value;
        var rp1 = document.getElementById("relatedProduct1");
        var rp2 = document.getElementById("relatedProduct2");
        var rp3 = document.getElementById("relatedProduct3");
        var discount = document.getElementById("discount");
        var codeML = document.getElementById("code-ml");
        var cost = document.getElementById("cost");
        var display = document.getElementById("display");
        var isNew = document.getElementById("isNew");
        var sku = document.getElementById("sku");
        var barCode = document.getElementById("bar_code");
        var prefix = '';
        
        if (type == "1"){
            prefix = 'AD';
        } else if (type == "2") {
            prefix = 'AB';
        } else if (type == "3") {
            prefix = 'AC';
        } else {
            prefix = 'AO';
        }
        if (provider == "1"){
            prefix += 'D';
        } else if (provider == "2"){
            prefix += 'A';
        } else {
            prefix += 'O';
        }

        var hasError = false;
        hasError = this.checkIsValid(name) || hasError;
        hasError = this.checkIsValid(price) || hasError;
        hasError = this.checkIsValid(minStock) || hasError;
        hasError = this.checkIsValid(suggestionStock) || hasError;
        hasError = this.checkIsValid(discount) || hasError;
        hasError = this.checkIsValid(sku) || hasError;
        hasError = this.checkIsValid(barCode) || hasError;

        var rpError = false;
        if (!rpError && rp1.value == rp2.value && rp1.value == rp3.value && rp1.value != -1) {
            rp1.className = "custom-select is-invalid";
            rp2.className = "custom-select is-invalid";
            rp3.className = "custom-select is-invalid";
            rpError = true;
        } else if (!rpError) {
            rp1.className = "custom-select";
            rp2.className = "custom-select";
            rp3.className = "custom-select";
        }
        if (!rpError && rp1.value == rp2.value && rp1.value != -1) {
            rp1.className = "custom-select is-invalid";
            rp2.className = "custom-select is-invalid";
            rpError = true;
        } else if (!rpError) {
            rp1.className = "custom-select";
            rp2.className = "custom-select";
        }
        if (!rpError && rp2.value == rp3.value && rp2.value != -1) {
            rp2.className = "custom-select is-invalid";
            rp3.className = "custom-select is-invalid";
            rpError = true;
        } else if (!rpError) {
            rp2.className = "custom-select";
            rp3.className = "custom-select";
        }
        if (!rpError && rp1.value == rp3.value && rp1.value != -1) {
            rp1.className = "custom-select is-invalid";
            rp3.className = "custom-select is-invalid";
            rpError = true;
        } else if (!rpError) {
            rp1.className = "custom-select";
            rp3.className = "custom-select";
        }

        if (parseInt(discount.value) > 100 || parseInt(discount.value) < 0 ) {
            hasError = true
            discount.className = "form-control is-invalid";
        }

        // Igual que en la ficha de juego: el stock sólo viaja en el ALTA. Guardar un accesorio
        // no mueve stock — se mueve con el ajuste (admin + comentario), que deja registro.
        var newStock = this.state.currentStock;
        if (!this.isEditing() && this.props.role == 1) {
            var newStockItem = document.getElementById("stock");
            hasError = this.checkIsValid(newStockItem) || hasError;
            if (!hasError) {
                newStock = newStockItem.value
            }
        }

        // Un id mal tipeado no puede guardarse en silencio: el backend lo descarta, pero el
        // usuario se iría creyendo que el producto quedó vinculado y el stock nunca sincronizaría.
        const mlInvalidos = externalIdsInvalidos(this.state.externalIds);
        if (mlInvalidos.length > 0) {
            hasError = true;
            alert(
                `Estos IDs de MercadoLibre no son válidos: ${mlInvalidos.join(', ')}.\n` +
                `Un ID de publicación es "MLU" seguido de números (ej: MLU123456789). ` +
                `Corregilos o borrá el renglón con la X.`
            );
        }

        if (!hasError && !rpError) {
            var rpList = [];
            if (rp1.value != -1) { rpList.push(parseInt(rp1.value)); }
            if (rp2.value != -1) { rpList.push(parseInt(rp2.value)); }
            if (rp3.value != -1) { rpList.push(parseInt(rp3.value)); }
            const payload = {
                code: this.state.code,
                prefix: prefix,
                name: name.value,
                price: parseFloat(price.value),
                description: this.state.text,
                ...(this.isEditing() ? {} : { stock: newStock }),
                minStock: parseInt(minStock.value),
                suggestionStock: parseInt(suggestionStock.value),
                provider: provider,
                type: type,
                images: images,
                // Habilita el paso destructivo de imágenes en EditProductPage. No viaja a la API
                // (buildProductPayload arma el body con campos explícitos).
                imagesReady: !this.state.imagesLoading,
                relatedProducts: rpList,
                externalItems: limpiarExternalIds(this.state.externalIds),
                discount: parseInt(discount.value),
                display: display.value,
                sku: sku.value,
                barCode: barCode.value,
                codeML: "",                
                cost: cost.value
            };

            // DIRTY-TRACKING de "Novedad". `isNew` sólo viaja si el operador tocó el control.
            //
            // Del otro lado esto ya no es una columna del producto sino la membresía en la
            // colección "Novedades", y el backend lee la AUSENCIA de la key como "no toques la
            // membresía". Este form emite el objeto COMPLETO leído del DOM, con lo que cargó al
            // abrir la ficha; si `isNew` viajara siempre, corregir una falta de ortografía a las
            // 10:10 reescribiría la curación con lo que la ficha leyó a las 10:00 — y si el
            // dueño sacó ese accesorio de Novedades a las 10:05 desde el ABM de colecciones,
            // VUELVE SOLO. Es la misma clase de bug que el "reemplazo total desde el snapshot
            // viejo" que la Fase 2 retiró del ABM, entrando ahora por la ficha del producto.
            //
            // En ALTA (`loadedIsNew === null`) no hay valor previo contra el cual comparar, así
            // que el campo SÍ tiene que viajar: si no, el default "Sí" no escribiría nada.
            const isNewValue = isNew.value === 'true';
            if (this.state.loadedIsNew === null || this.state.loadedIsNew !== isNewValue) {
                payload.isNew = isNew.value;
            }

            this.props.onChangeData(payload);
        } else {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }
    }

    /* Images */
    onCropperInit(cropper) {
        this.cropper = cropper;
    }

    cropImage = () => {
        if (typeof this.cropper.getCroppedCanvas() === "undefined" || this.cropper.getCroppedCanvas() === null) { return; }
        
        var mapImages = this.state.images;

        var url = this.cropper.getCroppedCanvas({
            maxWidth: 2048,
            maxHeight: 2048,
            imageSmoothingEnabled: true,
            imageSmoothingQuality: 'high',
        }).toDataURL('image/jpeg');

        var url_thumb = this.cropper.getCroppedCanvas({
            maxWidth: 512,
            maxHeight: 512,
            imageSmoothingEnabled: true,
            imageSmoothingQuality: 'high',
        }).toDataURL('image/jpeg');

        if (mapImages[1] == undefined || mapImages[1] == '') {
            mapImages[1] = { path: url, thumb: url_thumb, position: 1 }
        }  
        else if (mapImages[2] == undefined || mapImages[2] == '') {
            mapImages[2] = { path: url, thumb: url_thumb, position: 2 }
        } 
        else if (mapImages[3] == undefined || mapImages[3] == '') {
            mapImages[3] = { path: url, thumb: url_thumb, position: 3 }
        } 
        else if (mapImages[4] == undefined || mapImages[4] == '') {
            mapImages[4] = { path: url, thumb: url_thumb, position: 4 }
        } 
        else if (mapImages[5] == undefined || mapImages[5] == '') {
            mapImages[5] = { path: url, thumb: url_thumb, position: 5 }
        } 
        else if (mapImages[6] == undefined || mapImages[6] == '') {
            mapImages[6] = { path: url, thumb: url_thumb, position: 6 }
        } 

        this.setState({ images: mapImages });
    }

    rotateImage = (rotate) => {
        if (typeof this.cropper.getCroppedCanvas() === "undefined" || this.cropper.getCroppedCanvas() === null) { return; }
        this.cropper.rotate(rotate);    
    }

    onChange = (e) => {
        e.preventDefault();
        let files;
        if (e.dataTransfer) {
          files = e.dataTransfer.files;
        } else if (e.target) {
          files = e.target.files;
        }
        try {
            const reader = new FileReader();
            reader.onload = () => {
              this.setState({ src: reader.result });
            };
            reader.readAsDataURL(files[0]);
        } catch (error) {}
    }

    handleClickFile = () => {
        document.getElementById("file").click();
    }

    handleUpdatePositions = (imagesUpdated) => {
        this.setState({ images: imagesUpdated})
    }

    handleImagesDeleted = (position) => {
        var newList = this.state.images;
        newList[position] = '';
        this.setState({ images: newList });
    }

    addExternalId = () => {
        // Arranca VACÍO. Antes se empujaba la cadena literal "New", que si el usuario guardaba
        // sin escribir nada quedaba persistida como si fuera un id de publicación.
        var newList = this.state.externalIds;
        newList.push("");
        this.setState({ externalIds: newList });
    }

    handleExternalIdChange = (index, event) => {
        let data = [...this.state.externalIds];
        data[index] = event.target.value;
        this.setState({ externalIds: data });
     }

     deleteExternalId = (index) => {
        let data = [...this.state.externalIds];
        data.splice(index, 1)
        this.setState({ externalIds: data });
     }
     

    showExternalIds = () => {    
        return (<div className="form-row mx-4">            {
                this.state.externalIds.map((externalId, index) => {      
                        return (
                         <div className="form-row">
                            <div key={index} className="form-group col-md-8">
                                <input type="text" className="form-control" placeholder="MLU123456789" value= {externalId} onChange={event => this.handleExternalIdChange(index, event)}/>
                            </div>
                            
                            <div className="form-group col-md-4">
                                <button type="button" onClick={() => this.deleteExternalId(index)} class="mb-2 btn btn-outline-danger mr-2">X</button>
                            </div>
                        </div>
                        )
                }) 
            }       
        </div> )
                                
    }

    renderProviders = () => {
        if (this.state.providers.length === 0) {
            return (
                <select id="provider" className="custom-select" defaultValue="2">
                    <option value="1">DEVIR</option>
                    <option value="2">Asmodee</option>
                    <option value="3">Dragón Azul</option>
                    <option value="4">Maldito Games</option>
                    <option value="100">Otro</option>
                </select>
            );
        }

        return (
            <select id="provider" className="custom-select" defaultValue="2">
                {this.state.providers.map(provider => (
                    <option key={provider.providerId} value={provider.providerId}>
                        {provider.name}
                    </option>
                ))}
            </select>
        );
    }

	render() {
        return (  
            <div className="col-lg-11 mx-auto mt-4">
                <div className="card card-small edit-user-details mb-4">
                    <div className="card-body p-0">
                        <form action="#" className="py-4">
                            <div className="form-row mx-4">
                                <div className="col mb-3">
                                    <h6 className="form-text m-0">Detalles generales del producto</h6>
                                </div>
                            </div>
                            <div className="form-row mx-4">
                                <div className="form-group col-md-2">
                                    <label>Código</label>
                                    <input type="text" className="form-control" id="code" placeholder="Ingrese código" defaultValue={this.state.prefix + this.state.code} disabled/>
                                </div>
                                <div className="form-group col-md-6">
                                    <label>Nombre</label>
                                    <input type="text" className="form-control" id="name" placeholder="Ingrese nombre del accesorio (*)"/>
                                </div>
                                <div className="form-group col-md-4">
                                    <label>Tipo</label>
                                    <select id="type" className="custom-select">                                    
                                        <option value="3">Fundas</option>
                                        <option value="5">Bolsos</option>
                                        <option value="1">Dados</option>
                                        <option value="2">Cajas</option>
                                        <option value="4">Otro</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-row mx-4">
                                <div className="form-group col-md-3">
                                    <label>Proveedor</label>
                                    {this.renderProviders()}
                                </div>
                                <div className="form-group col-md-3">
                                    <label>Precio</label>
                                    <div className="input-group input-group-seamless">
                                        <div className="input-group-prepend">
                                            <div className="input-group-text">
                                                <i className="material-icons">attach_money</i>
                                            </div>
                                        </div>
                                        <input type="number" min="0" className="form-control" id="price" placeholder="Precio del accesorio (*)"/>
                                    </div>
                                </div>
                                <div className="form-group col-md-3">
                                    <label>Descuento</label>
                                    <div className="input-group input-group-seamless">
                                        <div className="input-group-prepend">
                                            <div className="input-group-text">
                                                %
                                            </div>
                                        </div>
                                        <input type="number" min="0" className="form-control" id="discount" placeholder="Descuento del producto (*)"/>
                                    </div>
                                </div>
                                <div className="form-group col-md-3" style={{display: (this.props.role == 1 && this.state.editMode) ? 'block' : 'none'}}>
                                    <label>Costo total</label>
                                    <div className="input-group input-group-seamless">
                                        <div className="input-group-prepend">
                                            <div className="input-group-text">
                                                $
                                            </div>
                                        </div>
                                        <input type="number" min="0" className="form-control" id="cost" placeholder="Costo del producto (*)"/>
                                    </div>
                                </div>
                                <div className="form-group col-md-3">
                                    <label>Código de barras</label>
                                    <div className="input-group input-group-seamless">
                                        <input type="number" min="0" className="form-control" id="bar_code" placeholder="Código de barras del producto (*)"/>
                                    </div>
                                </div>
                                <div className="form-group col-md-3">
                                    <label>SKU</label>
                                    <div className="input-group input-group-seamless">
                                        <input type="text" className="form-control" id="sku" placeholder="SKU del producto (*)"/>
                                    </div>
                                </div>
                                <div className="form-group col-md-3">
                                    <label>Code ML</label>
                                    <div className="input-group input-group-seamless">
                                        <input type="text" className="form-control" id="code-ml" placeholder="Código de Mercado Libre"/>
                                    </div>
                                </div>
                                <div className="form-group col-md-3">
                                    <label>Mostrar en la WEB</label>
                                    <select id="display" className="custom-select">
                                        <option value="true" selected>Si</option>
                                        <option value="false">No</option>
                                    </select>
                                </div>
                                <NovedadFieldComponent
                                    isEditing={ this.isEditing() }
                                    labels={ this.state.labels }
                                />
                            </div>
                            <ReactQuill
                                value={ this.state.text }
                                placeholder="Ingrese la descripción del producto"
                                onChange={ this.handleChangeDescription }
                            />
                            <hr />
                            <div className="form-row mx-4">
                                <div className="col mb-3">
                                    <h6 className="form-text m-0">Stock del producto</h6>
                                </div>
                            </div>
                            <div className="form-row mx-4">
                                {this.props.role == 1 && !this.isEditing() && (
                                    <div className="form-group col-md-4">
                                        <label>Stock inicial</label>
                                        <input type="number" min="0" className="form-control" id="stock" placeholder="Stock inicial (*)"/>
                                    </div>
                                )}
                                {this.isEditing() && (
                                    <div className="form-group col-md-4">
                                        <label>Stock</label>
                                        <div className="d-flex align-items-center">
                                            <span style={{ fontSize: '1.4rem', fontWeight: 500 }}>{this.state.currentStock}</span>
                                            {this.props.role == 1 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-white ml-3"
                                                    onClick={() => this.setState({ adjustingStock: true })}
                                                >
                                                    <i className="material-icons" style={{ fontSize: '16px', verticalAlign: 'middle' }}>tune</i> Ajustar stock
                                                </button>
                                            )}
                                        </div>
                                        <small className="text-muted">
                                            Guardar el producto no cambia el stock. Se mueve con ventas, reposiciones,
                                            conteos, o con un ajuste (que pide motivo).
                                        </small>
                                    </div>
                                )}
                                <div className="form-group col-md-4">
                                    <label>Stock mínimo</label>
                                    <input type="number" min="0" className="form-control" id="minStock" placeholder="Stock mínimo (*)"/>
                                </div>
                                <div className="form-group col-md-4">
                                    <label>Stock sugerido</label>
                                    <input type="number" min="0" className="form-control" id="suggestionStock" placeholder="Stock sugerido (*)"/>
                                </div>
                            </div>
                            <hr />
                            <div className="form-row mx-4">
                                <div className="col mb-3">
                                    <h6 className="form-text m-0">Productos relacionados</h6>
                                </div>
                            </div>
                            <div className="form-row mx-4">
                                <div className="form-group col-md-4">
                                    <label>Producto 1</label>
                                    <select id="relatedProduct1" className="custom-select">
                                        <option value="-1">- Ninguno -</option>
                                    </select>
                                </div>
                                <div className="form-group col-md-4">
                                    <label>Producto 2</label>
                                    <select id="relatedProduct2" className="custom-select">
                                        <option value="-1">- Ninguno -</option>
                                    </select>
                                </div>
                                <div className="form-group col-md-4">
                                    <label>Producto 3</label>
                                    <select id="relatedProduct3" className="custom-select">
                                        <option value="-1">- Ninguno -</option>
                                    </select>
                                </div>                                
                            </div>
                            <div className="form-row mx-4">
                                    <div className="col mb-3">
                                        <h6 className="form-text m-0">Identificadores de ML</h6>
                                    </div>
                            </div>
                            <div id = "ML-Ids" style={{paddingLeft:'5px'}} >            
                                {this.showExternalIds()}                    
                                <div className="form-row form-group mx-4 ">
                                    <button onClick={() => this.addExternalId()} style={{width: "140px"}} type="button" class="mb-2 btn btn-outline-dark mr-2">Agregar Id de ML</button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <hr />
                    <div className="form-row mx-4">
                        <div className="col mb-3">
                            <h6 className="form-text m-0">Imágenes del producto</h6>
                        </div>
                    </div>
                    <div className="form-row mx-4">
                        <div className="form-group col-md-6">
                            <Cropper
                                style={{ height: 500, width: "100%", background: "#eaeaea"}}
                                aspectRatio={1}
                                guides={true}
                                src={this.state.src}
                                viewMode={1}
                                dragMode="move"
                                rotatable={true}
                                cropBoxMovable={false}
                                onInitialized={this.onCropperInit.bind(this)} />
                            <div className="form-row mx-4" style={{marginTop: '15px'}}>
                                <div className="form-group col-md-3">
                                    <input type="file" id="file" ref="fileUploader" style={{display: "none"}} onChange={ this.onChange }/>
                                    <button onClick={() => this.handleClickFile()} style={{width: "100%"}} type="button" class="mb-2 btn btn-outline-primary mr-2">Agregar</button>
                                </div>
                                <div className="form-group col-md-3"></div>
                                <div className="form-group col-md-3">
                                    <button onClick={() => this.rotateImage(90)} style={{width: "100%"}} type="button" class="mb-2 btn btn-outline-dark mr-2">Rotar</button>
                                </div>
                                <div className="form-group col-md-3">
                                    <button onClick={() => this.cropImage()} style={{width: "100%"}} type="button" class="mb-2 btn btn-outline-success mr-2">Confirmar</button>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <GridImagesComponent  
                                images={this.state.images}
                                onUpdatePositions={ this.handleUpdatePositions }
                                onImageDeleted={ this.handleImagesDeleted } />
                        </div>
                    </div>

                    <div className="mb-3 progress" style={{height: "5px"}}>
                        <div className="progress-bar bg-danger" role="progressbar" aria-valuemin="0" aria-valuemax="100" style={{width: `${this.props.uploadValue}%`}} />
                    </div>

                    {this.precargaIncompleta() && (
                        <div className="alert alert-danger mx-4" role="alert">
                            <strong>La ficha no se cargó completa.</strong> Lo que ves en pantalla
                            no es lo que hay guardado, así que el botón Guardar está bloqueado
                            para no pisar los datos del accesorio. Recargá la pantalla.
                        </div>
                    )}

                    <div className="card-footer border-top">
                        <button onClick={() => this.onClickSave()} type="button" className="mb-2 btn btn-primary mr-2" style={{float: 'right'}} disabled={this.props.disabled || this.state.imagesLoading || this.precargaIncompleta()}>Guardar</button>
                        {this.state.imagesLoading && (
                            <span className="text-muted" style={{float: 'right'}}>Cargando las imágenes del accesorio…&nbsp;&nbsp;</span>
                        )}
                    </div>
                </div>

                {/* El stock del accesorio se mueve por acá y sólo por acá. */}
                <StockAdjustModal
                    show={this.state.adjustingStock}
                    product={{ code: this.props.code, name: this.state.currentName, stock: this.state.currentStock }}
                    onClose={() => this.setState({ adjustingStock: false })}
                    onDone={(data) => this.setState({
                        adjustingStock: false,
                        currentStock: data && data.newStock != null ? data.newStock : this.state.currentStock,
                    })}
                />
            </div>
        );
    }
}

export default FormBoxGameComponent;
